import _classPrivateFieldLooseBase from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classPrivateFieldLooseBase.js";
import _classPrivateFieldLooseKey from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classPrivateFieldLooseKey.js";
var _focused, _cleanup, _setup;
// src/focusManager.ts
import { Subscribable } from "./subscribable.js";
import { isServer } from "./utils.js";
var FocusManager = (_focused = /*#__PURE__*/_classPrivateFieldLooseKey("focused"), _cleanup = /*#__PURE__*/_classPrivateFieldLooseKey("cleanup"), _setup = /*#__PURE__*/_classPrivateFieldLooseKey("setup"), class FocusManager extends Subscribable {
  constructor() {
    super();
    Object.defineProperty(this, _focused, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _cleanup, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _setup, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldLooseBase(this, _setup)[_setup] = onFocus => {
      if (!isServer && window.addEventListener) {
        const listener = () => onFocus();
        window.addEventListener("visibilitychange", listener, false);
        return () => {
          window.removeEventListener("visibilitychange", listener);
        };
      }
      return;
    };
  }
  onSubscribe() {
    if (!_classPrivateFieldLooseBase(this, _cleanup)[_cleanup]) {
      this.setEventListener(_classPrivateFieldLooseBase(this, _setup)[_setup]);
    }
  }
  onUnsubscribe() {
    if (!this.hasListeners()) {
      var _classPrivateFieldLoo, _classPrivateFieldLoo2;
      (_classPrivateFieldLoo = (_classPrivateFieldLoo2 = _classPrivateFieldLooseBase(this, _cleanup))[_cleanup]) === null || _classPrivateFieldLoo === void 0 || _classPrivateFieldLoo.call(_classPrivateFieldLoo2);
      _classPrivateFieldLooseBase(this, _cleanup)[_cleanup] = void 0;
    }
  }
  setEventListener(setup) {
    var _classPrivateFieldLoo3, _classPrivateFieldLoo4;
    _classPrivateFieldLooseBase(this, _setup)[_setup] = setup;
    (_classPrivateFieldLoo3 = (_classPrivateFieldLoo4 = _classPrivateFieldLooseBase(this, _cleanup))[_cleanup]) === null || _classPrivateFieldLoo3 === void 0 || _classPrivateFieldLoo3.call(_classPrivateFieldLoo4);
    _classPrivateFieldLooseBase(this, _cleanup)[_cleanup] = setup(focused => {
      if (typeof focused === "boolean") {
        this.setFocused(focused);
      } else {
        this.onFocus();
      }
    });
  }
  setFocused(focused) {
    const changed = _classPrivateFieldLooseBase(this, _focused)[_focused] !== focused;
    if (changed) {
      _classPrivateFieldLooseBase(this, _focused)[_focused] = focused;
      this.onFocus();
    }
  }
  onFocus() {
    const isFocused = this.isFocused();
    this.listeners.forEach(listener => {
      listener(isFocused);
    });
  }
  isFocused() {
    var _globalThis$document;
    if (typeof _classPrivateFieldLooseBase(this, _focused)[_focused] === "boolean") {
      return _classPrivateFieldLooseBase(this, _focused)[_focused];
    }
    return ((_globalThis$document = globalThis.document) === null || _globalThis$document === void 0 ? void 0 : _globalThis$document.visibilityState) !== "hidden";
  }
});
var focusManager = new FocusManager();
export { FocusManager, focusManager };